import React from 'react';
import styles from './custom-checkbox.module.scss';

const CustomCheckbox = ({
  label,
  checked,
  onChange,
  id,
  disabled = false,
  testid = '',
  ...props
}) => {
  return (
    <div className={styles.checkboxContainer}>
      <input
        type="checkbox"
        id={id}
        className={styles.checkboxInput}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        data-testid={testid}
        aria-checked={checked}
        {...props}
      />
      <label htmlFor={id} className={styles.checkboxLabel}>
        {/* The custom visual checkbox */}
        <span className={styles.customCheckbox}></span>
        {/* Optional label text */}
        {label && <span className={styles.labelText}>{label}</span>}
      </label>
    </div>
  );
};

export default CustomCheckbox;
